import React from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGE_GRANT_TOKEN from './paths';
import Privileges from 'auth/ActivatePrivilege';
function PrivilegesRoute() {
  return /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: PRIVILEGE_GRANT_TOKEN(':token')
  }, /*#__PURE__*/React.createElement(Privileges, null));
}
export default PrivilegesRoute;